export const iconSizeSmall = '16px';
export const iconSizeMedium = '18px';
export const iconSizeLarge = '21px';
export const iconSizeExtraLarge = '25px';
